var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$vuetify.breakpoint.xsOnly)?_c('MobileTitleWithBack',[_vm._v(" User Information ")]):_vm._e(),_c('v-row',{class:_vm.$vuetify.breakpoint.smAndUp ? 'pl-8' : ''},[(_vm.$vuetify.breakpoint.smAndUp)?_c('v-col',{attrs:{"cols":"4"}},[_c('ProfileNavigation')],1):_vm._e(),_c('v-col',[_c('UserInfo')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }